import { z } from 'zod';
/**
 * Achievements and titles (ADR 0046). The client asks for its list, picks a
 * title and claims a reward; the server derives what is done from its own
 * records and refuses anything else.
 */
const AchievementIdSchema = z.string().min(1).max(32);
/** Nothing to say but "show me". */
export const AchievementsRequestSchema = z.object({}).strict();
/** To the owner alone: where every achievement stands, and what is worn and claimed. */
export const AchievementsEventSchema = z.object({
    progress: z.record(AchievementIdSchema, z.object({ value: z.number().int().min(0), target: z.number().int().min(0) })),
    /** The title worn (an achievement's id, or a shop title's), or null. */
    title: AchievementIdSchema.nullable(),
    /** Achievements whose reward has been claimed. */
    claimed: z.array(AchievementIdSchema),
    /** Shop titles the account may wear (`shop-titles.ts`): offers it paid for and kept. */
    shopTitles: z.array(AchievementIdSchema).default([]),
    /** A game master may wear any title, earned or not, to try them (ADR 0046). */
    anyTitle: z.boolean().default(false),
});
/** To the owner alone, as it happens: what was just done. */
export const AchievementUnlockedSchema = z.object({ ids: z.array(AchievementIdSchema).min(1) });
/** Wear a title (an achievement's id, or a shop title's), or none. */
export const SetTitleMessageSchema = z.object({ achievementId: AchievementIdSchema.nullable() });
/** Take an achievement's item. */
export const ClaimAchievementMessageSchema = z.object({ achievementId: AchievementIdSchema });
export const ACHIEVEMENT_REFUSALS = [
    'invalid',
    'unknown',
    'no-reward',
    'not-done',
    'claimed',
    'no-title',
    'bag-full',
];
export const AchievementRejectedSchema = z.object({ reason: z.enum(ACHIEVEMENT_REFUSALS) });
//# sourceMappingURL=achievements.js.map